// src/js/helpers/dom.js
// Small DOM helper utilities shared across modules.

export function safeQuery(selector) {
  try { return document.querySelector(selector); } catch (e) { return null; }
}

export function findAll(sel) {
  try { return Array.from(document.querySelectorAll(sel)); } catch (e) { return []; }
}

export function createObserverForSelector(selector, onFound, opts = {}) {
  const timeout = opts.timeout || 3000;
  if (safeQuery(selector)) { onFound(); return null; }
  const mo = new MutationObserver((mutations, obs) => {
    if (safeQuery(selector)) { obs.disconnect(); onFound(); }
  });
  mo.observe(document.documentElement || document.body, { childList: true, subtree: true });
  setTimeout(() => { try { mo.disconnect(); } catch (e) {} }, timeout);
  return mo;
}

export default { safeQuery, findAll, createObserverForSelector };
